import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const TermsCreative = () => {
  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      {/* Header */}
      <div className="bg-white border-b border-gray-100">
        <div className="max-w-3xl mx-auto px-6 py-4">
          <div className="flex items-center gap-4">
            <Link to="/signup" className="text-gray-400 hover:text-black transition-colors">
              <ArrowLeft className="w-5 h-5" />
            </Link>
            <h1 className="text-xl font-bold tracking-tight">Terms & Conditions for Creatives</h1>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-3xl mx-auto px-6 py-8">
        <div className="bg-white rounded-2xl p-6 md:p-8 prose prose-gray max-w-none">
          <p className="text-gray-600 mb-6">By creating an account, you agree to the following:</p>
          
          <p className="text-gray-600 mb-6">
            This platform is a marketplace that allows independent photographers and videographers ("Creatives") 
            to connect with organizations seeking creative services. The platform does not employ Creatives and 
            does not provide creative services itself.
          </p>

          <h2 className="text-lg font-semibold mt-8 mb-4">Independent Contractor Status</h2>
          <p className="text-gray-600 mb-6">
            You acknowledge that you operate as an independent contractor. You are solely responsible for your work, 
            pricing, taxes, insurance, licenses, equipment, permits, and compliance with all applicable laws. 
            Nothing on the platform creates an employment or agency relationship.
          </p>

          <h2 className="text-lg font-semibold mt-8 mb-4">Project Agreements</h2>
          <p className="text-gray-600 mb-6">
            For each booking, you and the organization will confirm project details such as deliverables, timelines, 
            pricing, and revision limits through a shared project agreement. This agreement reflects the scope of work 
            you have agreed to perform and serves as a reference point for both parties.
          </p>

          <h2 className="text-lg font-semibold mt-8 mb-4">Deliverables & Revisions</h2>
          <p className="text-gray-600 mb-6">
            You agree to deliver work in accordance with the agreed scope and revision limits. If a client requests 
            changes beyond the agreed number of revisions, you may offer additional revisions at your discretion and 
            at a mutually agreed price.
          </p>
          <p className="text-gray-600 mb-6">
            If a dispute arises and the platform is asked to review the project, the platform may determine, at its 
            sole discretion, whether you have reasonably fulfilled the agreed scope. If you have met your obligations, 
            the client may be required to accept the work or purchase additional revisions.
          </p>

          <h2 className="text-lg font-semibold mt-8 mb-4">Failure to Deliver</h2>
          <p className="text-gray-600 mb-6">
            If you fail to deliver the agreed-upon work without resolution, funds held in escrow may be refunded to 
            the client. The platform reserves the right to restrict or remove your account in cases of repeated 
            non-delivery or misconduct.
          </p>

          <h2 className="text-lg font-semibold mt-8 mb-4">Platform Role & Liability</h2>
          <p className="text-gray-600 mb-6">
            The platform does not guarantee bookings, income, or project outcomes. It is not responsible for client 
            decisions, project changes, delayed communication, or disputes beyond facilitating communication and 
            escrow where applicable.
          </p>

          <h2 className="text-lg font-semibold mt-8 mb-4">Limitation of Liability</h2>
          <p className="text-gray-600 mb-6">
            To the fullest extent permitted by law, the platform is not liable for any damages, losses, or claims 
            arising from your use of the platform or your relationship with clients.
          </p>

          <h2 className="text-lg font-semibold mt-8 mb-4">Account Standing</h2>
          <p className="text-gray-600 mb-6">
            The platform reserves the right to review, suspend, or remove accounts at its discretion to protect 
            the integrity of the marketplace.
          </p>

          <h2 className="text-lg font-semibold mt-8 mb-4">Acceptance</h2>
          <p className="text-gray-600">
            By creating an account, you acknowledge that you understand and agree to these terms and that you 
            participate in the platform voluntarily and at your own risk.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsCreative;
